import { Button, Grid } from '@mui/material';
import { Skeleton } from '@mui/material';
import { Link } from 'react-router-dom';
import Select from '../../components/FormInputs/Select/Select';
import TitledMessage from '../../components/TitledMessage';
import LangEnum from '../../lang/LangEnum';
import teceoSelectConfig from '../../utils/TeceoSelectConfig';
import { useTranslation } from '../translation/TranslationContext';

type DropboxFolderSelectionProps = {
  loading?: boolean;
  center?: boolean;
  withConfigLink?: boolean;
  selectedFolder?: string;
  onChange: (folder: string) => void;
  value?: string;
  folders: any[];
};
const DropboxFolderSelection = ({
  withConfigLink,
  onChange,
  folders,
  value,
  center,
  loading,
}: DropboxFolderSelectionProps) => {
  const { translate } = useTranslation();

  return (
    <Grid
      container
      spacing={2}
      sx={{
        justifyContent: center ? 'center' : undefined,
      }}
    >
      {folders && folders.length > 0 && (
        <>
          <Grid size={12}>
            <TitledMessage
              title={translate(LangEnum.DROPBOX_FOLDER_SELECTION_TITLE)}
              message={translate(LangEnum.DROPBOX_FOLDER_SELECTION_MESSAGE)}
              center={center}
            />
          </Grid>
          <Grid style={{ marginBottom: '24px' }} size="auto">
            <Select
              style={{ minWidth: 200, marginBottom: 5 }}
              {...teceoSelectConfig}
              label={translate(LangEnum.DROPBOX_FOLDER_SELECTION_LABEL)}
              items={folders.map((folder) => ({ label: folder.name, value: folder.pathLower }))}
              onChange={(e: any) => onChange(e.target.value)}
              defaultValue={value}
            />
          </Grid>
        </>
      )}

      {(!folders || folders.length === 0) && (
        <>
          <Grid size={12}>
            <TitledMessage
              loading={loading}
              title={translate(LangEnum.DROPBOX_FOLDER_SELECTION_EMPTY_TITLE)}
              message={translate(LangEnum.DROPBOX_FOLDER_SELECTION_EMPTY_MESSAGE)}
              center={center}
            />
          </Grid>
          {withConfigLink && (
            <Grid size="auto">
              {loading && <Skeleton width={200} height={40} />}
              {!loading && (
                <Link component={Button} color="primary" to="/settings/general-settings">
                  {translate(LangEnum.DROPBOX_FOLDER_SELECTION_BACK_TO_SETTINGS)}
                </Link>
              )}
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default DropboxFolderSelection;
